export function getRowCardOrders(hasWater: boolean): {
  water: number,
  trends: number,
  efficiency: number
} {
  return {
    water: 2,
    trends: 0,
    efficiency: 2,
  };
}
